import {
  ICollectionSite,
  IDistributionSite,
  IFactorySite,
  IFarmSite,
  IForestSite,
  IGenericSite,
  IGroceryStoreSite,
  IHandlingSite,
  IManufacturingSite,
  IMineSite,
  IOriginSite,
  IPlantSite,
  IProcessingSite,
  IWarehouseSite,
} from 'FeatureModules/Site/types/site.types';

// Fix union issue with Apollo Client
export const possibleSiteTypes = {
  Site: [
    'GenericSite',
    'Farm',
    'Mine',
    'Forest',
    'CollectionSite',
    'OriginSite',
    'Plant',
    'ProcessingSite',
    'Factory',
    'ManufacturingSite',
    'Warehouse',
    'HandlingSite',
    'GroceryStore',
    'DistributionSite',
    'SiteCluster',
  ],
};

/*
  We need to define common keyFields for each site type to avoid cache conflicts.
  By default, Apollo uses the __typename and id fields to identify cache objects, but __typename differs for each site type.
*/
const sitePolicies = {
  Query: {
    fields: {
      // This is needed to merge the site data correctly
      site: {
        merge: true,
      },
    },
  },
  Farm: {
    keyFields: ({ id, lang }: IFarmSite) => `Site:${id}-${lang}`,
  },
  GenericSite: {
    keyFields: ({ id, lang }: IGenericSite) => `Site:${id}-${lang}`,
  },
  SiteCluster: {
    keyFields: ({ id, lang }: IGenericSite) => `Site:${id}-${lang}`,
  },
  Mine: {
    keyFields: ({ id, lang }: IMineSite) => `Site:${id}-${lang}`,
  },
  Forest: {
    keyFields: ({ id, lang }: IForestSite) => `Site:${id}-${lang}`,
  },
  CollectionSite: {
    keyFields: ({ id, lang }: ICollectionSite) => `Site:${id}-${lang}`,
  },
  OriginSite: {
    keyFields: ({ id, lang }: IOriginSite) => `Site:${id}-${lang}`,
  },
  Plant: {
    keyFields: ({ id, lang }: IPlantSite) => `Site:${id}-${lang}`,
  },
  ProcessingSite: {
    keyFields: ({ id, lang }: IProcessingSite) => `Site:${id}-${lang}`,
  },
  Factory: {
    keyFields: ({ id, lang }: IFactorySite) => `Site:${id}-${lang}`,
  },
  ManufacturingSite: {
    keyFields: ({ id, lang }: IManufacturingSite) => `Site:${id}-${lang}`,
  },
  Warehouse: {
    keyFields: ({ id, lang }: IWarehouseSite) => `Site:${id}-${lang}`,
  },
  HandlingSite: {
    keyFields: ({ id, lang }: IHandlingSite) => `Site:${id}-${lang}`,
  },
  GroceryStore: {
    keyFields: ({ id, lang }: IGroceryStoreSite) => `Site:${id}-${lang}`,
  },
  DistributionSite: {
    keyFields: ({ id, lang }: IDistributionSite) => `Site:${id}-${lang}`,
  },
};

export default sitePolicies;
